// guards/account-type.guard.ts
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { StoreService } from 'shared/services/store.service';

@Injectable({
  providedIn: 'root'
})
export class AccountTypeGuard  {
  constructor(
    private router: Router,
    protected readonly storeService: StoreService) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    
    try {
      const account = await firstValueFrom(this.storeService.getAccount());
      const accountType = account.accountType;
      const requiredAccountType = route.data['requiredAccountType'];

      if (accountType === requiredAccountType) {
        return true;
      }
      
      await this.router.navigate(['/']);
      return false;
    } catch (error) {
      console.error('Error checking account type:', error);
      await this.router.navigate(['/login']);
      return false;
    }
  }
}